import { render, staticRenderFns } from "./CodingRuleList.vue?vue&type=template&id=e12a473a&scoped=true&"
import script from "./CodingRuleList.vue?vue&type=script&lang=js&"
export * from "./CodingRuleList.vue?vue&type=script&lang=js&"
import style0 from "./CodingRuleList.vue?vue&type=style&index=0&id=e12a473a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12a473a",
  null
  
)

export default component.exports